export default __webpack_public_path__ + "img/triangle.37fd9dd.svg";